import {
  Container,
  Content,
  Heading,
} from 'features/menu/components/product-detail/product-detail-flow/dialogs/body-component/styled';

interface IBodyComponent {
  heading: string;
  content: string;
}

export const BodyComponent = ({ heading, content }: IBodyComponent) => (
  <Container>
    {heading && <Heading>{heading}</Heading>}
    {content && <Content>{content}</Content>}
  </Container>
);
